import { GenericStatus } from "./props";

const OrderPriceUpdateStatus: GenericStatus[] = [
    {key: "requested", text: "Requested", tagVariant: 'active'},
    {key: "approved", text: "Approved", tagVariant: 'success'},
    {key: "rejected", text: "Rejected", tagVariant: 'error'}
]

export default OrderPriceUpdateStatus;